import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/ArrowForward';

class ArrowForwardIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default ArrowForwardIcon;
